module.exports = __webpack_public_path__ + "static/media/10.14047c0f.jpg";